import GoogleMaps from "./components/GoogleMaps";

window.addEventListener("DOMContentLoaded", () => {
  console.log("essa");
  const maps = document.querySelectorAll(".wrapper__map");

  maps.forEach((map) => {
    const id = map.getAttribute("id");
    const data = window[id];

    if (data) {
      new GoogleMaps(map, data);
    }
  });

  // if (typeof map !== "undefined") {
  //   const localization = new GoogleMaps(map, window.map_global_vars);
  // }
});
